import { Component } from '@angular/core';
import { Router ,RouterLink} from '@angular/router';


@Component({
  selector: 'app-cancellation-policy-page',
  imports: [RouterLink],
  templateUrl: './cancellation-policy-page.html',
  styleUrl: './cancellation-policy-page.css'
})
export class CancellationPolicyPage {
constructor(private router: Router ) {}

     navigateAndScroll(route: string ,x:number=0,y:number=0) {
    this.router.navigate([route]).then(() => {
      window.scrollTo(x, y);
    });}
    scrollToTop() {
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 0);
}

}
